/* eslint-disable */
import React, { useState, useCallback, useEffect } from "react";
import { Input, FileUpload, Button, BrandIconSpinner } from "components";
import { useSelector, useDispatch } from "react-redux";
import { JobApply, jobsubmit } from "redux/features/PostJobSlice";
import { Notification } from "components/CustomNotification";
import { TemplatesStyle } from "./CreateForm.style";
import { DialogActions, IconButton } from "@mui/material";
import AutoComplete from "components/AutoComplete";
import { ExperienceList } from "assert/OptionList";
import { EmailRegex } from "utils/helper";
import { useTranslation } from "react-i18next";

import { ReactComponent as Add } from 'assert/images/Profile/add.svg';

function Template2({ closeModal, handleSelectTemplate, handleSuccessClose, apply, jobState, setInitialState, setStateChangedValue }) {
  const dispatch = useDispatch();
  const { t } = useTranslation(); 
  const [disable, setdisable] = useState(false);
  const { getProfile } = useSelector((state) => state?.ProfileSlice);

  const [isLoading, setIsLoading] = useState(false);
  const [newSkill, setNewSkill] = useState('');
  const [state, setState] = useState({
    Name: "",
    Email: "",
    Skills: "",
    Phone: "",
    AnyThingElse: "",
    resume: "",
    skill: "",
    experience: "",
  });

  const [errMsg, setErrmsg] = useState({
    Name: "",
    Email: "",
    Phone: "",
    resume: "",
    skill: "",
    experience: "",
  });

  useEffect(() => {
    setInitialState && setInitialState(JSON.stringify(state));
  }, [])

  useEffect(() => {
    apply ? setdisable(false) : setdisable(true);
  }, [apply]);

  const handleChange = useCallback((data, name, type) => {
    setStateChangedValue(JSON.stringify({ ...state, [name]: data?.target?.value || data }));
    setState((prevState) => ({
      ...prevState,
      [name]: data,
    }));
  }, []);

  const handleValidation = () => {
    Object.keys(errMsg).forEach((data) => {
      return (errMsg[data] = state[data] === "" ? "Field Required" : "");
    });
    if (!state.Email.match(EmailRegex))
      errMsg.Email = 'Email is Invalid';
    else errMsg.Email = '';
    setErrmsg((prevState) => ({
      ...prevState,
    }));
  };

  const handleCloseModal = () => {
    handleSelectTemplate(JSON.stringify(state));
  };

  const Submit = (boln, type) => {
    handleValidation(boln, type);
    const validation = Object.keys(errMsg).every((data) => {
      return errMsg[data] === "";
    });

    if (validation) {
      setIsLoading(true);
      const formData = new FormData();
      formData.append("JobPostId", jobState?.jobPostId);
      formData.append("jobPostedBy", jobState?.jobPostedUserInfo?.userId);
      formData.append("userId", getProfile?.userId);
      formData.append("skill", JSON.stringify(state.skill));
      formData.append("experience", state.experience);
      formData.append("userEmail", getProfile?.userEmail);
      formData.append(
        "data",
        JSON.stringify({
          Name: state.Name,
          Email: state.Email,
          Phone: state.Phone,
          AnyThingElse: state.AnyThingElse,
        })
      );
      formData.append("resume", state.resume?.[0]);
      dispatch(JobApply(formData))
        .then((res) => {
          handleSuccessClose(jobState?.jobPostId);
          dispatch(jobsubmit(""));
          Notification("success", res?.data?.message);
          setIsLoading(false);
        })
        .catch(() => {
          Notification("warning", "Something went wrong");
          setIsLoading(false);
        });
    }
    setErrmsg((prevState) => ({
      ...prevState,
    }));
  };

  const handleAddSkill = () => {
    if (newSkill.trim() !== '') {
      const updatedSkills = [...state.skill, newSkill];
      handleChange(updatedSkills, 'skill');
      setNewSkill('');
    }
  };

  return (
    <TemplatesStyle>
      <BrandIconSpinner loading={isLoading} />
      <Input
        label={t('Job.Name')}
        value={state.Name}
        errMsg={errMsg.Name}
        required
        onChange={(data) => handleChange(data, "Name")}
        disabled={disable}
      />
      <div className="field-wrap">
        <Input
          label={t('Job.Email')}
          required
          value={state.Email}
          errMsg={errMsg.Email}
          onChange={(data) => handleChange(data, "Email")}
          disabled={disable}
        />
        <Input
          label={t('Job.Phone')}
          type="text"
          required
          value={state.Phone}
          errMsg={errMsg.Phone}
          maxLimit={20}
          onChange={(data) => {
            const sanitizedValue = data.replace(/[^0-9+]/g, "");
            handleChange(sanitizedValue, "Phone")
          }}
          disabled={disable}
        />
      </div>
      <div className="field-comment">
        <Input
          multiline
          minRows={4}
          maxLimit={600}
          label={t('Job.AnythingShare')}
          value={state.AnyThingElse}
          disabled={disable}
          onChange={(data) => handleChange(data, "AnyThingElse")}
        />
      </div>
      <FileUpload
        label={t('Job.Resume')}
        required
        value={state.resume}
        errMsg={errMsg.resume}
        handleFileSRC={(data) => handleChange(data, "resume", "file")}
        disabled={disable}
      />
      {!disable && (
        <div>
          <div className="static-field-wrap">
            <div className="static-skills-container">
              <AutoComplete
                freeSolo
                multiple
                required
                label={"Skills"}
                value={state.skill}
                errMsg={errMsg.skill}
                onChange={(data) => handleChange(data, "skill")}
                autoCompleteInputValue={newSkill}
                onInputChange={(_, newInputValue) => setNewSkill(newInputValue)}
                Options={[]}
                textPlaceholder={"Press enter or add"}
              />
              <IconButton
                className="static-skill-icon-btn"
                aria-label="toggle password visibility"
                onClick={handleAddSkill}
                edge="end"
                size="small"
              >
                <Add />
              </IconButton>
            </div>
            <AutoComplete
              required
              label={"Total year of experience"}
              value={state.experience}
              errMsg={errMsg.experience}
              onChange={(data) => handleChange(data, "experience")}
              Options={ExperienceList}
            />
          </div>
          <div className="static-field-helper">
            Note: Check the skills and experience, it's play the major role while select the applicant
          </div>
        </div>
      )}
      <DialogActions>
        <Button variant="text" label={apply ? "Submit" : t('Job.SelectTemplate2')} onClick={() => (apply ? Submit() : handleCloseModal())} />
        <Button variant="text" label={t('Job.Cancel')} onClick={closeModal} />
      </DialogActions>
    </TemplatesStyle>
  );
}

export default Template2;